export function cleanHtmlText(rawHtml: string): string {
  //  Unescape \u003C style (JSON encoding for < > etc.)
  const unescaped = rawHtml.replace(/\\u003C/g, '<').replace(/\\u003E/g, '>')

  //  Decode HTML entities like &#xa0; (non-breaking space), etc.
  const textarea = document.createElement('textarea')
  textarea.innerHTML = unescaped
  const decoded = textarea.value

  //  Remove HTML tags (but preserve some formatting)
  const withLineBreaks = decoded
    .replace(/<\/p>|<\/li>|<\/h\d>/gi, '\n') // paragraph, list item ends
    .replace(/<li>/gi, '- ') // list items
    .replace(/<[^>]+>/g, '') // strip all other tags

  //   Clean up extra whitespace
  return withLineBreaks
    .split('\n')
    .map(line => line.trim()) // trims leading & trailing spaces per line
    .filter(line => line !== '') // removes empty lines
    .join('\n')
}
